import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useUrlTracking = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        if (window.hj) {
            hj('stateChange', pathname);
        }
        if (window._hsq) {
            _hsq.push(['setPath', pathname]);
            _hsq.push(['trackPageView']);
        }
    }, [pathname]);
};

export default useUrlTracking;
